exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".vocabulary-list .dnn-persona-bar-page-body .vocabulary-error {\n  font-size: 15px;\n  padding: 25px;\n  color: #C8C8C8;\n  text-transform: uppercase;\n}\n", ""]);

